import { memo, useContext, useEffect, useRef, useState } from 'react';
import { SUBSCRIBE_RETRY_TIME } from '../../../constant';
import { AVContext } from '../../../context';
import useAVActions from '../../hooks/useAVActions';
const AVSubscriber = memo(props => {
    const { av } = useContext(AVContext);
    const { peer, videoType, subscribeToVideo, audioVolume = 100 } = props;
    const peedId = peer.id;
    const videoStream = videoType === 'camera' ? peer.av?.stream : peer.screen?.stream;
    const [retryCount, setRetryCount] = useState(0);
    const subscriberRef = useRef();
    const audioVolumeRef = useRef(audioVolume);
    const retryTimerRef = useRef();
    const unmountedRef = useRef(false);
    const { enableAudio } = useAVActions();
    audioVolumeRef.current = audioVolume;
    useEffect(() => {
        const subscribe = async (stream) => {
            try {
                subscriberRef.current = await av.subscribe(stream, audioVolumeRef.current);
                enableAudio(peedId, audioVolumeRef.current === 100);
            }
            catch (error) {
                if (!unmountedRef.current) {
                    retryTimerRef.current = window.setTimeout(() => {
                        setRetryCount(retryCount + 1);
                    }, SUBSCRIBE_RETRY_TIME);
                }
            }
        };
        if (videoStream) {
            subscribe(videoStream);
        }
    }, [av, enableAudio, peedId, retryCount, videoStream]);
    useEffect(() => {
        if (subscriberRef.current && subscribeToVideo !== undefined) {
            subscriberRef.current.subscribeToVideo(subscribeToVideo);
        }
    }, [subscribeToVideo]);
    useEffect(() => {
        if (subscriberRef.current) {
            enableAudio(peedId, audioVolumeRef.current === 100);
        }
    }, [enableAudio, peedId, audioVolume]);
    useEffect(() => {
        return () => {
            if (subscriberRef.current) {
                av.unsubscribe(subscriberRef.current);
            }
        };
    }, [av]);
    useEffect(() => {
        return () => {
            if (retryTimerRef.current) {
                clearTimeout(retryTimerRef.current);
                retryTimerRef.current = undefined;
            }
            unmountedRef.current = true;
        };
    }, []);
    return null;
});
export default AVSubscriber;
//# sourceMappingURL=av-subscriber.js.map